import { CamerasDesktopView } from './CamerasDesktopView';

export function CamerasTabletView() {
  return <CamerasDesktopView />;
}
